import angular from "angular";
import catalogModule from '../catalogModule';

function itemCardController($log, $scope, catalogConstants) {
    "ngInject";
    $scope.hasSecondaryInfo = function () {
        return $scope.item.creatorTargetId !== catalogConstants.robloxSystemUserId
            || $scope.item.unitsAvailableForConsumption > 0
            || ($scope.item.price > 0 && $scope.item.lowestPrice > 0);
    }

    $scope.isCreatorNameShown = function () {
        return $scope.item && $scope.item.creatorTargetId !== catalogConstants.robloxSystemUserId && $scope.item.creatorName;
    }

    $scope.isItemThumbnailLoading = function () {
        if ($scope.item.itemType === catalogConstants.itemTypes.bundle) {
            return !$scope.layout.isBundleThumbnailLoaded;
        } else {
            return !$scope.layout.isAssetThumbnailLoaded;
        }
    }

    $scope.isItemThumbnailAvailable = function () {
        return $scope.item.thumbnail && $scope.item.thumbnail.imageUrl;
    }

    $scope.clickItemCard = function (e) {
        if (!$scope.item.detailsUrl) {
            e.preventDefault();
        }
    }
}

catalogModule.controller("itemCardController", itemCardController);

export default itemCardController;